// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import interactionPlugin from "@fullcalendar/interaction";

// const DaysCalendar = ({ events, onDateClick, onEventClick }) => {
//   return (
//     <FullCalendar
//       plugins={[dayGridPlugin, interactionPlugin]}
//       initialView="dayGridMonth"
//       events={events}
//       dateClick={onDateClick}
//       eventClick={onEventClick}
//       eventContent={renderEventContent}
//       hiddenDays={[0]} // 0 represents Sunday
//     />
//   );
// };

// function renderEventContent(eventInfo) {
//   return (
//     <div
//       style={{
//         background: eventInfo.event.extendedProps.clr,
//         color: "#fff",
//         overflow: "hidden",
//         borderRadius: "4px",
//       }}
//       className="fc-daygrid-dot-event"
//     >
//       <div className="fc-daygrid-event-dot"></div>
//       <div className="fc-event-time">{eventInfo.timeText}</div>
//       <div className="fc-event-title">{eventInfo.event.title}</div>
//     </div>
//   );
// }

// export default DaysCalendar;


import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

const DaysCalendar = ({ events, onDateClick, onEventClick }) => {
  return (
    <FullCalendar
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      events={events}
      dateClick={onDateClick}
      eventClick={onEventClick}
      eventContent={renderEventContent}
      // 🛠️ FIXED: Removed hiddenDays={[0]} to show Sunday
    />
  );
};

function renderEventContent(eventInfo) {
  return (
    <div
      style={{
        background: eventInfo.event.extendedProps.clr,
        color: "#fff",
        overflow: "hidden",
        borderRadius: "4px",
      }}
      className="fc-daygrid-dot-event"
    >
      <div className="fc-daygrid-event-dot"></div>
      <div className="fc-event-time">{eventInfo.timeText}</div>
      <div className="fc-event-title">{eventInfo.event.title}</div>
    </div>
  );
}

export default DaysCalendar;